import { useCallback } from "react";

import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import useActivityTracker from "hooks/useActivityTracker";
import useAuthentication from "hooks/useAuthentication";

export default function DataSubscriptionsWidget() {
  const { trackActivity } = useActivityTracker();
  const { account } = useAuthentication();

  const onDownloadCatalog = useCallback(
    (e) => {
      e.preventDefault();

      trackActivity("data_subscription.button_download_click", {
        type: "accounts",
        id: account?.id,
      });

      window.open(
        "https://docs.smartkarma.com/catalogue_links/Smartkarma%20Data%20Subscriptions%20Summary.pdf",
        "_blank",
        "location=yes"
      );
    },
    [account?.id, trackActivity]
  );

  const onGetInTouch = useCallback(() => {
    trackActivity("data_subscription.button_contact_click", {
      type: "accounts",
      id: account?.id,
    });
  }, [account?.id, trackActivity]);

  return (
    <CustomCard className="p-[15px] py-[30px] text-center overflow-hidden">
      <div
        className={twMerge(
          "bg-ink-pink",
          "text-[12px] leading-[1]",
          "py-[2px] px-[20px]",
          "absolute top-[8px] right-[-16px]",
          "rotate-45 text-white"
        )}
      >
        NEW
      </div>
      <div className="text-center">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="https://assets.smartkarma.com/icons/atom-utah.svg"
          alt="Data Subscriptions"
          width={58}
          height={58}
          className="pb-[2px] mb-[10px]"
        />
        <div
          className={classNames(
            "font-[900]",
            "text-[22px]",
            "text-active-black tracking-[0.44px]"
          )}
        >
          Data Subscriptions
        </div>
        <div className="text-[18px] mt-[12px] mb-[23px]">
          Access premium, alternative datasets for unique insights into public
          and private markets
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center">
            <a
              href="#"
              onClick={onDownloadCatalog}
              className={twMerge(
                "p-[7px] px-[40px]",
                "border border-solid border-utah-sky rounded-full",
                "w-full",
                "text-utah-sky text-[16px] font-bold bg-white hover:text-white hover:bg-utah-sky"
              )}
              target="_blank"
            >
              Download Data Catalog
            </a>
          </div>
          <a
            onClick={onGetInTouch}
            href="mailto:sales@smartkarma.com"
            className="text-utah-sky py-[15px] mb-[-15px] w-[100%] hover:text-utah-sky/70"
            target="_blank"
          >
            Get in touch for more information
          </a>
        </div>
      </div>
    </CustomCard>
  );
}
